import { Component, HostListener, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ToolEnum } from 'src/Models/Common';
import { FilterModel } from 'src/Models/filterModel';
import { SeminarsModel } from 'src/Models/SeminarsModel';
import { SeminarService } from 'src/Services/seminar.service';
import { CheckAuth } from 'src/Services/utility.service';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import * as FileSaver from 'file-saver';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-seminars',
  templateUrl: './seminars.component.html',
  styleUrls: ['./seminars.component.css']
})
export class AdminSeminarsComponent implements OnInit {

  filterModel = new FilterModel();
  currentPage: number = 1;
  totalRecordCount: number = -1;

  listOfSeminars: SeminarsModel[];
  listOfSeminarsExport: SeminarsModel[];

  isUserSystemAdmin: boolean = true;
  tokenKey: string = '';
  SelectedTool: string;

  isAscending: boolean = false
  upDowTitleCSS: string = '';
  upDowURLCSS: string = '';
  upDowIsActiveCSS: string = '';
  upDowCreatedDateCSS: string = '';
  upDowModifiedDateCSS: string = '';
  upDowSortOrderCSS: string = '';
  upDowSectionCSS: string = '';

  productId: number = 1;
  deletedId: number = 0;
  isloading: boolean;
  dropdownSettingsStatus = {};
  dropdownSettingsFree = {};
  listOfStatus = [];
  statusId: string = ' ';
  listOfFree = [];
  freeId: string = ' ';
  moduleList: any[] = [{ itemName: 'Yes', id: '1' }, { itemName: 'No', id: '0' }];
  dropdownListSection = [];
  dropdownSettingsSections = {};
  selectedItemsSections = [];
  listOfSectionID: string[] = [];
  selectedItemsSection = [];
  listOfSection?: string;
  PageNumber: number;
  specialReportId: number = 0;
  openMenuIndex: number = -1;

  constructor(private readonly activedRoute: ActivatedRoute,
    private readonly Seminar: SeminarService,
    private readonly router: Router,
    private readonly checkAuth: CheckAuth,
    private readonly titleService: Title,
    private readonly toastr: ToastrService,
    private sessionStorageService: SessionStorageService
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.SelectedTool = this.sessionStorageService.getUserLoginTool();
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.productId = ToolEnum[this.SelectedTool];
    this.titleService.setTitle('Seminars');
    this.filterModel.pageNumber = '1';
    this.filterModel.pageSize = '10';
    this.filterModel.orderBy = 'SortOrder';
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  ngOnInit() {
    this.dropdownSettingsSections = {
      singleSelection: true,
      text: "Filter by Sections",
      enableSearchFilter: true,
      classes: 'borderLessTextBoxGreen',
      noDataLabel: 'No Section available',
    };
    this.dropdownSettingsStatus = {
      singleSelection: true,
      text: "Filter by Active",
      enableSearchFilter: false,
      classes: "borderLessTextBoxGreen",
      badgeShowLimit: 3,
      noDataLabel: 'No record available',
      showCheckbox: false
    };
    this.activedRoute.params.subscribe((params: Params) => {
      if (params['id']) {
        if (params['id'] != null) {

          this.specialReportId = params['id'];
          this.GetSeminarsData();
        }
      }
    });
    this.GetSeminarsData();
    this.getAllSections();

  }

  GetSeminarsData() {
    this.isloading = true;
    this.listOfSeminars = [];
    this.filterModel.IsExport = false;
    this.Seminar.i360SeminarsGet(this.tokenKey, this.filterModel).subscribe(
      data => {
        this.isloading = false;
        if (data != null) {
          this.listOfSeminars = data['seminarsData'];
          if (this.listOfSeminars != null) {
            if (this.listOfSeminars.length > 0) {
              this.totalRecordCount = this.listOfSeminars[0].totalRecordCount;
            }
            else {
              this.totalRecordCount = 0;
            }
          }
          else {
            this.totalRecordCount = 0;
          }
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  keywordFilters($event) {
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    if ($event.target.value != "" && $event.target.value != null) {
      this.filterModel.whereCondition = $event.target.value;
    }
    else {
      this.filterModel.whereCondition = '';
    }
    this.GetSeminarsData();
  }

  pageChanged($event: any) {
    this.currentPage = $event.page;
    this.filterModel.pageNumber = parseInt($event.page).toString();
    this.GetSeminarsData();
  }

  sort(sortBy: any) {
    this.upDowTitleCSS = '';
    this.upDowIsActiveCSS = '';
    this.upDowCreatedDateCSS = '';
    this.upDowModifiedDateCSS = '';
    this.upDowSortOrderCSS = '';
    this.upDowSectionCSS = '';

    if (!this.isAscending) {
      this.isAscending = true;
      this.filterModel.orderBy = sortBy + ' DESC';

      if (sortBy === "title") {
        this.upDowTitleCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "isActive") {
        this.upDowIsActiveCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "CreatedDate") {
        this.upDowCreatedDateCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "ModifiedDate") {
        this.upDowModifiedDateCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "sortOrder") {
        this.upDowSortOrderCSS = 'fa fa-arrow-down';
      }
      else if (sortBy === "sectionName") {
        this.upDowSectionCSS = 'fa fa-arrow-down';
      }
    }
    else {
      this.isAscending = false;
      this.filterModel.orderBy = sortBy;

      if (sortBy === "title") {
        this.upDowTitleCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "isActive") {
        this.upDowIsActiveCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "CreatedDate") {
        this.upDowCreatedDateCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "ModifiedDate") {
        this.upDowModifiedDateCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "sortOrder") {
        this.upDowSortOrderCSS = 'fa fa-arrow-up';
      }
      else if (sortBy === "sectionName") {
        this.upDowSectionCSS = 'fa fa-arrow-up';
      }
    }
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.GetSeminarsData();
  }

  addSeminar() {
    this.router.navigate(['admin/jsi360/Seminar/manage']);
  }

  editData(id) {
    this.router.navigate(['admin/jsi360/Seminar/manage/' + id])
  }

  setDeleteData(ids) {
    this.deletedId = ids;
  }

  deleteRecord(deletedId) {
    this.Seminar.i360SeminarsDelete(this.tokenKey, deletedId).subscribe(
      data => {
        this.deletedId = 0;
        if (data != null) {
          if (data['deletedId'] > 0) {
            this.GetSeminarsData();
            this.toastr.success('Record deleted successfully.', 'Delete')
          }
        }
      },
      error => {
      }
    );
  }

  getAllSections() {
    this.Seminar.i360SeminarsSectionListWithIds(this.tokenKey).subscribe(data => {
      if (data['status'] !== 'Failure') {
        for (let iCounter = 0; iCounter < data['sectionList'].length; iCounter++) {
          this.dropdownListSection.push(
            { 'id': data['sectionList'][iCounter].sectionId, 'itemName': data['sectionList'][iCounter].sectionName }
          );
        }
        if (this.listOfSectionID != null && this.listOfSectionID != undefined) {
          for (let iCounter = 0; iCounter < this.listOfSectionID.length; iCounter++) {
            if (this.listOfSectionID[iCounter] != '') {
              let obj = data["sectionList"].filter(m => m.productId == this.listOfSectionID[iCounter]);
              if (obj != null) {
                this.selectedItemsSection.push({ "id": obj[0].sectionId, "itemName": obj[0].sectionName });
              }
            }
          }
        }

      }
    });
  }

  onSelectStatus($event) {
    this.listOfStatus = this.removeElemetninArray(this.listOfStatus, $event.id)
    this.listOfStatus.push($event.id);
    this.statusId = ' ';
    if (this.listOfStatus.length > 0) {
      this.statusId = $event.id;
      this.filterModel.statusId = this.statusId;
    } else {
      this.filterModel.statusId = null;
    }

    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.GetSeminarsData();
  }

  onDeSelectStatus($event) {
    if (this.listOfStatus != null) {
      if (this.listOfStatus.length > 0) {
        this.listOfStatus = this.removeElemetninArray(this.listOfStatus, $event.id)
      }
    }
    this.statusId = '';
    if (this.listOfStatus.length > 0) {
      this.statusId = $event.id;
    }
    this.filterModel.statusId = null;
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.GetSeminarsData();
  }

  onDeSelectAllStatus($event) {
    this.statusId = '';
    this.listOfStatus = [];
    this.filterModel.statusId = null;
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.GetSeminarsData();
  }

  removeElemetninArray(array, element) {
    return array.filter(e => e !== element);
  }

  onSelect($event) {
    if (this.listOfSectionID != null) {
      this.listOfSectionID = [];
      if (this.listOfSectionID.length > 0) {
        this.listOfSectionID = this.removeElemetninArray(this.listOfSectionID, $event.id)
        this.listOfSectionID.push($event.id);
      }
      else {
        this.listOfSectionID.push($event.id);
      }
    }

    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.listOfSection = this.listOfSectionID.join(',');
    this.filterModel.section = this.listOfSection;
    this.GetSeminarsData();
  }

  onSelectAll($event) {
    for (const item of $event) {
      if (this.listOfSectionID != null) {
        if (this.listOfSectionID.length > 0) {
          this.listOfSectionID = this.removeElemetninArray(this.listOfSectionID, item.id)
          this.listOfSectionID.push(item.id);
        }
        else {
          this.listOfSectionID.push(item.id);
        }
      }
    }

    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.listOfSection = this.listOfSectionID.join(',');
    this.filterModel.section = this.listOfSection;
    this.GetSeminarsData();
  }

  onDeSelectAll($event) {
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    this.listOfSectionID = [];
    this.listOfSection = '';
    this.filterModel.section = this.listOfSection;
    this.GetSeminarsData();
  }

  onDeSelect($event) {
    this.filterModel.pageNumber = '1';
    this.currentPage = 1;
    if (this.listOfSectionID != null) {
      if (this.listOfSectionID.length > 0) {
        this.listOfSectionID = this.removeElemetninArray(this.listOfSectionID, $event.id)
      }
    }
    this.listOfSection = this.listOfSectionID.join(',');
    this.filterModel.section = this.listOfSection;
    this.GetSeminarsData();
  }

  drop(event: CdkDragDrop<string[]>): void {
    var CurrentShortOrder, PreviousShortOrder, currentcustomProductDetailsId, previouscustomProductDetailsId
    PreviousShortOrder = this.listOfSeminars[event.previousIndex]['sortOrder']
    previouscustomProductDetailsId = this.listOfSeminars[event.previousIndex]['seminarId']

    CurrentShortOrder = this.listOfSeminars[event.currentIndex]['sortOrder']
    currentcustomProductDetailsId = this.listOfSeminars[event.currentIndex]['seminarId']

    this.Seminar.i360SeminarReportUpdate(this.tokenKey, previouscustomProductDetailsId, currentcustomProductDetailsId).subscribe(
      data => {
        this.deletedId = 0;
        if (data != null) {
          this.Seminar.i360SeminarsGet(this.tokenKey, this.filterModel).subscribe(
            data => {
              this.isloading = false;
              if (data != null) {
                this.listOfSeminars = data['seminarsData'];
                if (this.listOfSeminars != null) {
                  if (this.listOfSeminars.length > 0) {
                    this.totalRecordCount = this.listOfSeminars[0].totalRecordCount;
                  }
                  else {
                    this.totalRecordCount = 0;
                  }
                }
                else {
                  this.totalRecordCount = 0;
                }
              }
            },
            error => {
              this.isloading = false;
              console.log(error);
            }
          );
        }
      },
      error => {
      }
    );

  }

  toggleMenu(index: number) {
    this.openMenuIndex = this.openMenuIndex === index ? -1 : index; // Toggle the menu
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (!target.closest('.kebab-menu')) {
      this.openMenuIndex = null;
    }
  }

  ExportSeminar() {
    this.isloading = true;
    this.listOfSeminarsExport = [];
    this.filterModel.IsExport = true;
    this.Seminar.i360SeminarsGet(this.tokenKey, this.filterModel).subscribe(
      data => {
        if (data != null) {
          this.listOfSeminarsExport = data['seminarsData'];
          if (this.listOfSeminarsExport != null) {
            if (this.listOfSeminarsExport.length > 0) {
              setTimeout(() => {
                this.DownloadSeminar();
                this.isloading = false;
              }, 1000);
            }
            else {
              this.isloading = false;
              this.toastr.error("No record found", "Error");
            }
          }
          else {
            this.isloading = false;
            this.toastr.error("No record found", "Error");
          }
        }
      },
      error => {
        this.isloading = false;
        console.log(error);
      }
    );
  }

  DownloadSeminar() {
    let tableData = document.getElementById("ExportTable").innerHTML;

    var uri = 'data:application/vnd.ms-excel;base64,'
      , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body>{table}</body></html>'
      , base64 = function (s) { return window.btoa(unescape(encodeURIComponent(s))) }
      , format = function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p]; }) }
    let html = "<table><tr class='mainhead'> <td colspan='3'>";
    html += tableData;
    html += "</td></tr></table>";
    let name = 'ExportJSi360Seminars';
    var ctx = { worksheet: name || 'Worksheet', table: html }
    FileSaver.saveAs((uri + base64(format(template, ctx))), "ExportJSi360Seminars.xls");
  }
}
